import { menuClick } from 'store/ui/uiActions';
import { createMenuClickEvent } from '../eventCreators';
import { createMenuClickEventPayload } from '../dataHelpers/createMenuClickEventPayload';

const emitMenuClickEvent = ({ payload }) => {
  return createMenuClickEvent(
    createMenuClickEventPayload({
      itemText: payload?.itemText,
      url: payload?.url,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [menuClick]: emitMenuClickEvent };
